<template>
  <DSelect
    :items="dSelectItems"
    :multiple="true"
    :placeholder="$t('vue2.substitution.choose_absence_user')"
    @update="sendUpdate"
  ></DSelect>
</template>
<script>
import DSelect from '../DSelect/DSelect'
import docendo from '../../docendo'
export default {
  components: {DSelect},
  props: {
    items: {
      default: () => [],
      type: Array
    },
    itemsSelected: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      tags: []
    }
  },
  computed: {
    schoolId () {
      return window.SCHOOL && window.SCHOOL.id
    },
    dSelectItems () {
      return this.items.concat(this.tagsForSelect)
    },
    tagsForSelect () {
      // tag_id is a hardcoded value greater than largest userid
      let tags = []
      let i = 0
      this.tags.forEach(tag => {
        i++
        let oneTag = {
          tag: true,
          id: 999999999999 + i,
          name: tag,
          icon: 'icon-price-tag2'
        }
        tags.push(oneTag)
      })
      return tags
    }
  },
  methods: {
    sendUpdate ($event) {
      this.$emit('update', $event)
    },
    getTags () {
      docendo.schoolTags(this.schoolId, data => {
        this.tags = data
      })
    }
  },
  beforeMount () {
    this.getTags()
  }
}
</script>



// WEBPACK FOOTER //
// SubsCreateDSelect.vue?46aa6608